import CryptoJS from "crypto-js";
import env from '../env';

const key = env.VUE_APP_CRYPTR_KEY;
const encrypt = (string) => {
  var ciphertext = CryptoJS.AES.encrypt(string, key).toString();
  return ciphertext;
};

// Our stickers carry `<owner>|<kind>|<rest>` since the payload was shortened
// to keep the printed code readable from arm's length. Anything else of ours
// is the older JSON object, and anything that is not ours at all — an LME
// sticker is plain text — comes back untouched for the caller to recognise.
const COMPACT_PAYLOAD = /^[A-Za-z0-9]\|[WI]\|.+$/;

const decrypt = (ciphertext) => {
  try {
    const plain = CryptoJS.AES.decrypt(ciphertext, key).toString(
      CryptoJS.enc.Utf8
    );
    if (!plain) {
      return ciphertext;
    }
    if (COMPACT_PAYLOAD.test(plain)) {
      return plain;
    }
    return JSON.parse(plain);
  } catch (error) {
    return ciphertext;
  }
};

export { encrypt, decrypt };
